import { render, staticRenderFns } from "./LessonsTableSample.vue?vue&type=template&id=1b06824f&"
import script from "./LessonsTableSample.vue?vue&type=script&lang=js&"
export * from "./LessonsTableSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports